import { ICustomer, ISupplier } from '../graphql/schema/p4types';

/**
 * Returns an array of email addresses extracted from the provided customer or supplier
 *
 * @param obj - the customer or supplier
 */
export const getEmailAddresses = (obj?: ICustomer | ISupplier) => {
  const addresses: string[] = [];

  if (obj?.email) {
    addresses.push(obj.email);
  }

  obj?.contacts
    ?.filter((contact) => !contact!.archived)
    .map((contact) => contact!.email)
    .filter((email) => email !== undefined && email !== null)
    .forEach((email) => {
      addresses.push(email as string);
    });

  return addresses;
};
